const clickToggle = document.querySelectorAll('[data-toggle]');
const toggleOpen = 'toggle_open';
const toggleChildren = document.querySelectorAll('.toggle_child');

toggleChildren.forEach((Item) => {
	Item.setAttribute('hidden', '');
	Item.style.display = 'none';
});

for (const el of clickToggle) {
	document.addEventListener('click', function (event) {
		const toggleId = el.dataset.toggle;
		var value = el.getAttribute('aria-expanded');
		var toggleClose = document.getElementById(toggleId + '_close');
		if (event.target === el) {
			var toggleChild = document.getElementById(toggleId);
			if (value == 'true') {
				el.setAttribute('aria-expanded', 'false');
				toggleChild.setAttribute('hidden', '');
				setTimeout(() => (toggleChild.style.display = 'none'), 400);
				toggleChild.classList.remove(toggleOpen);
			} else {
				el.setAttribute('aria-expanded', 'true');
				toggleChild.removeAttribute('hidden');
				setTimeout(() => toggleChild.classList.add(toggleOpen), 400);
				toggleChild.style.display = 'flex';
			}
		} else if (event.target.closest('#content')) {
			var toggleChild = document.getElementById(toggleId);
			el.setAttribute('aria-expanded', 'false');
			toggleChild.classList.remove(toggleOpen);
			toggleChild.setAttribute('hidden', '');
			setTimeout(() => (toggleChild.style.display = 'none'), 400);
			// don't return focus if elsewhere on the page clicked obvs
		} else if (event.target === toggleClose) {
			var toggleChild = document.getElementById(toggleId);
			el.setAttribute('aria-expanded', 'false');
			toggleChild.classList.remove(toggleOpen);
			toggleChild.setAttribute('hidden', '');
			setTimeout(() => (toggleChild.style.display = 'none'), 400);
			el.focus(); // return focus if close clicked
		}
	});
	document.addEventListener('keydown', function (e) {
		var value = el.getAttribute('aria-expanded');
		if (value == 'true') {
			if (e.key === 'Escape') {
				const toggleId = el.dataset.toggle;
				var toggleChild = document.getElementById(toggleId);
				el.setAttribute('aria-expanded', 'false');
				toggleChild.classList.remove(toggleOpen);
				toggleChild.setAttribute('hidden', '');
				setTimeout(() => (toggleChild.style.display = 'none'), 400);
				el.focus(); // return focus if ESC key
			}
		} else {
		}
	});
}
